module.exports = {"en-ZA":{"currency-short":{"style":"currency","currency":"ZAR","currencyDisplay":"symbol","maximumSignificantDigits":1},"currency":{"style":"currency","currency":"ZAR","currencyDisplay":"symbol"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/numbers.json
// module id = k8ri
// module chunks = 1